import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, ClearIcon, Flex, InputProps } from '@modusign/design-system';
import { ChangeEvent, useState } from 'react';

interface SearchInputProps extends InputProps {
  onClear?(): void;
}

function SearchInput(props: SearchInputProps) {
  const [value, setValue] = useState(props?.value ?? '');

  return (
    <Flex
      alignItems="center"
      border="1px solid"
      borderColor="formBorderNeutralBase"
      borderRadius="2px"
      justifyContent="space-between"
      px="5px"
      py="5px"
      sx={{
        boxShadow: 'inset 1px 1px 1px rgba(0, 0, 0, 0.06)',
      }}
    >
      <Flex alignItems="center" justifyContent="center" p="5px">
        <Box
          as={FontAwesomeIcon}
          color="textNeutralVeryLight"
          height="14px"
          icon={faSearch}
          width="14px"
        />
      </Flex>
      <Box
        as="input"
        flex="auto"
        {...props}
        value={value}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          setValue(event.target.value);
          props?.onChange?.(event);

          if (!event.target.value) {
            props?.onClear?.();
          }
        }}
      />
      {!!value && (
        <Box
          as="button"
          onClick={() => {
            props?.onClear?.();
            setValue('');
          }}
        >
          <ClearIcon />
        </Box>
      )}
    </Flex>
  );
}

export default SearchInput;
